<soft-page>
  <soft-page-header customClass="p-0">
    <soft-page-tab
      name="search"
      [icon]="'fa-regular fa-search'"
      [title]="'Suche'"
    ></soft-page-tab>
    <soft-page-tab
      name="scan"
      [icon]="'fa-regular fa-barcode-scan'"
      [title]="'Scan'"
    ></soft-page-tab>
    <soft-page-tab
      name="favorites"
      [icon]="'fa-regular fa-heart'"
      [title]="'Favoriten'"
    ></soft-page-tab>
    <soft-page-tab
      name="last-used"
      [icon]="'fa-regular fa-history'"
      [title]="'Letzte'"
    ></soft-page-tab>
  </soft-page-header>
  @if (fragment() === 'search') {
    <div class="relative mt-2">
      <soft-search-bar
        [lastSearchResults]="lastSearchResults()"
        [searchFn]="searchIt"
        [deleteAllFn]="deleteAllLastSearchResults"
        [(value)]="searchValue"
      >
      </soft-search-bar>
    </div>
    @if (!searchValue()) {
      <div
        class="flex flex-col flex-grow w-full items-center justify-center px-4 text-center mt-16"
      >
        <soft-icon name="fa-regular fa-magnifying-glass text-4xl mb-2">
          <i class="fa-magnifying-glass fa-regular mb-2 text-4xl"></i>
        </soft-icon>
        <h6 class="font-semibold text-lg text-center px-4">Bitte Suchbegriff eingeben</h6>
        <span class="text-sm text-light text-center px-4">
          Die Suche wird automatisch ausgeführt sobald mehr als zwei Buchstaben eingegeben
          werden</span
        >
      </div>
    } @else {
      <div
        class="flex flex-col flex-grow w-full items-center justify-center px-4 text-center mt-16"
      >
        <soft-loading-spinner></soft-loading-spinner>
        <h6 class="font-semibold text-lg text-center px-4">
          Suche nach "{{ searchValue() }}" läuft...
        </h6>
      </div>
    }
  } @else if (fragment() === 'scan') {
    <div class="mt-4">
      <soft-scan-button></soft-scan-button>
    </div>
  } @else if (fragment() === 'favorites') {
    <p>Favorites functionality is not implemented yet.</p>
  } @else if (fragment() === 'last-used') {
    <p>Last used functionality is not implemented yet.</p>
  }
  <!--pre>{{ all() | json }}</pre-->
</soft-page>
